/* unplugin-vue-components disabled */import { render } from "./software.vue?vue&type=template&id=06a4b9f0&scoped=true"
import script from "./software.vue?vue&type=script&lang=js"
export * from "./software.vue?vue&type=script&lang=js"

import "./software.vue?vue&type=style&index=0&id=06a4b9f0&scoped=true&lang=css"

import exportComponent from "D:\\PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP\\官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a4b9f0"]])

export default __exports__